
let currentProduct;
let iframeSrc;
let customer = 'kuontheavalyoufunrniturecom';
let eventListenerActive = false;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        // REMOVE PREV ELEMENTS IN CASE OF RELOAD
        const existingIframeWrapper = document.getElementById('mazing-div');
        if (existingIframeWrapper) {
            existingIframeWrapper.remove();
        }

        const existingThumb = document.getElementById('mazing-thumb');
        if (existingThumb) {
            existingThumb.remove();
        }

        // WAIT FOR INSERT ELEMENTS
        const imgGallery = await waitForElement('.product-gallery__media-list');
        const thumbGallery = await waitForElement('.product-gallery__thumbnail-list');

        // GENERATE IFRAME SRC BASED ON CUSTOMER, URL AND INPUT VALUES
        iframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: () => {
                const url = window.location.href;
                const parts = url.split("/");
                const product = parts.filter(part => part.trim() !== '').pop();
                const productParts = product.split('?');

                const variantPickers = document.querySelectorAll('.variant-picker__option-values');

                if (!eventListenerActive) {
                    eventListenerActive = true;
                    variantPickers.forEach(variantPicker => {
                        const inputs = variantPicker.querySelectorAll('input');
                        inputs.forEach(input => {
                            input.addEventListener('click', (event) => {
                                setTimeout(() => {
                                    initializeScript()
                                }, 450)
                            });
                        });
                    });
                }


                const checkedInputs = [];
                variantPickers.forEach(variantPicker => {
                    const checkedInput = variantPicker.querySelector('input:checked');
                    if (checkedInput) {
                        checkedInputs.push(checkedInput.value.trim().replace(/\s+/g, ''));
                    }
                });

                currentProduct = `${productParts[0]}`;

                if (checkedInputs.length > 0) {
                    console.log('checked Inputs', checkedInputs);
                    currentProduct += `-${checkedInputs.join('-')}`;
                }

                console.log('extracted sku: ' + currentProduct.toLowerCase());

                return currentProduct.toLowerCase();
            }
        });

        // STOP SCRIPT IF NO IFRAME SRC IS FOUND
        if (!iframeSrc) {
            console.log('iframeSrc not found, skipping update.');
            return;
        }

        // MAZING IFRAME START

        const iframeWrapper = document.createElement('div');
        iframeWrapper.classList.add('product-gallery__media', 'snap-center');
        iframeWrapper.style.overflow = 'hidden';
        iframeWrapper.style.top = '0';
        iframeWrapper.style.left = '0';
        iframeWrapper.style.paddingTop = 'min(400px, 100%)';
        iframeWrapper.style.maxWidth = '100%';
        iframeWrapper.style.marginLeft = 'auto';
        iframeWrapper.style.marginRight = 'auto';
        iframeWrapper.style.height = '100%';
        iframeWrapper.style.width = '100%';
        iframeWrapper.id = 'mazing-div';
        iframeWrapper.setAttribute('data-media-type', 'image');


        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.border = '0';
        iframe.style.height = '100%';
        iframe.style.left = '0';
        iframe.style.position = 'absolute';
        iframe.style.maxHeight = '100%';
        iframe.style.top = '0';
        iframe.style.width = '100%';
        iframe.setAttribute('allowusermedia', '');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('data-cy', 'cy-mazing-frame');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking');

        iframeWrapper.appendChild(iframe);
        const firstChild = imgGallery.children[0];
        imgGallery.insertBefore(iframeWrapper, firstChild.nextSibling);
        imgGallery.style.scrollBehavior = 'smooth';
        // ADD TO GALLERY ITEMS
        imgGallery._items.splice(1, 0, iframeWrapper);

        // MAZING IFRAME END

        // MAZING THUMB START
        const newThumbElement = document.createElement('button');
        newThumbElement.classList.add('product-gallery__thumbnail');
        newThumbElement.type = 'button';
        newThumbElement.id = 'mazing-thumb';

        const thumbImgWrapper = document.createElement('div');
        thumbImgWrapper.style.width = '100%';
        thumbImgWrapper.style.height = 'auto';
        thumbImgWrapper.style.backgroundColor = 'white';
        thumbImgWrapper.style.borderRadius = '0.375rem';

        const thumbImg = document.createElement('img');
        thumbImg.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
        thumbImg.style.display = 'block';
        thumbImg.style.width = '100%';
        thumbImg.style.height = 'auto';
        thumbImg.style.objectFit = 'contain';
        thumbImg.style.padding = '15%';
        thumbImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

        thumbImgWrapper.appendChild(thumbImg)
        newThumbElement.appendChild(thumbImgWrapper);

        if (thumbGallery.children.length >= 1) {
            thumbGallery.insertBefore(newThumbElement, thumbGallery.children[1]);
        } else {
            thumbGallery.appendChild(newThumbElement);
        }

        // ADD TO THUMB ITEMS
        thumbGallery.items.splice(1, 0, newThumbElement);

        // MAZING THUMB END

        // THUMB LISTENER START

        const updateAriaCurrent = (newActiveThumb) => {
            Array.from(thumbGallery.children).forEach(thumb => thumb.setAttribute('aria-current', 'false'));
            newActiveThumb.setAttribute('aria-current', 'true');
        };

        Array.from(thumbGallery.children).forEach((thumb, index) => {
            if (thumb.id !== 'mazing-thumb') {
                thumb.addEventListener('click', (event) => {
                    newThumbElement.setAttribute('aria-current', 'false');
                    iframeWrapper.classList.remove('is-selected')
                    updateAriaCurrent(thumb);
                    imgGallery.scrollLeft = imgGallery.children[index].offsetLeft;
                });
            }
        });

        // THUMB LISTENER END

        document.querySelector('.product-gallery__thumbnail-list').addEventListener('click', (e) => {
            const isMazing = e.target.closest('#mazing-thumb');
            if (isMazing) {
                e.stopImmediatePropagation();

                Array.from(thumbGallery.children).forEach(thumb => {
                    thumb.setAttribute('aria-current', 'false');
                });
                Array.from(imgGallery.children).forEach(img => {
                    img.classList.remove('is-selected');
                });

                updateAriaCurrent(newThumbElement);
                iframeWrapper.classList.add('is-selected');

                iframeWrapper.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
        }, true);

        // OBSERVER

        const observeClassChange = (element) => {
            if (!element) {
                console.warn('Element not found.');
                return;
            }

            const mutationCallback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (element.classList.contains('is-selected')) {

                            // HIDE EXTERN UI WHILE VIEWER IS SELECTED
                            const zoomElements = document.querySelectorAll('.product-gallery__zoom');
                            const cursorElements = document.querySelectorAll('.product-gallery__cursor');

                            zoomElements.forEach(zoomElement => {
                                zoomElement.style.setProperty('visibility', 'hidden', 'important');
                            });

                            cursorElements.forEach(cursorElement => {
                                cursorElement.style.setProperty('display', 'none', 'important');
                            });
                        } else {

                            // SHOW EXTERN UI WHILE VIEWER IS NOT SELECTED
                            const zoomElements = document.querySelectorAll('.product-gallery__zoom');
                            const cursorElements = document.querySelectorAll('.product-gallery__cursor');

                            zoomElements.forEach(zoomElement => {
                                zoomElement.style.setProperty('visibility', 'visible', 'important');
                            });

                            cursorElements.forEach(cursorElement => {
                                cursorElement.style.setProperty('display', 'block', 'important');
                            });
                        }
                    }
                }
            };

            const observer = new MutationObserver(mutationCallback);

            observer.observe(element, {
                attributes: true,
                attributeFilter: ['class'],
            });

            console.log('Observer started for class changes on mazing iframeWrapper.');
        };

        observeClassChange(iframeWrapper);


    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

// initializeScript();


